import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "kf-proptypes/widgets";

import { Link, LINK_SIZE } from "../link/index.jsx";

import styles from "./breadcrumb.css";

import RightArrowIcon from "./RightArrow.svg";

export const BREAD_CRUMB_SIZE = {
  LARGE: "type2"
};

export const BREADCRUMB_COLOR = {
  BLACK: "black",
  BLUE: "blue"
};

const BreadCrumbContext = createContext({});

export function Breadcrumb(props) {
  const { children, size, color = BREADCRUMB_COLOR.BLUE } = props;

  const childCount = React.Children.toArray(children).filter(
    (child) => child
  ).length;

  const breadCrumbInfo = useMemo(
    function getTreeInfo() {
      return { color: color };
    },
    [color]
  );

  return (
    <div
      className={`${styles.breadcrumb} ${styles[size] || ""} ${styles[color]}`}
      data-component="breadcrumb"
    >
      <BreadCrumbContext.Provider value={breadCrumbInfo}>
        {React.Children.map(children, (child, index) => {
          return (
            <React.Fragment>
              {child}
              {index < childCount - 1 && <RightArrowIcon />}
            </React.Fragment>
          );
        })}
      </BreadCrumbContext.Provider>
    </div>
  );
}

Breadcrumb.propTypes = {
  /** A list of `<BreadcrumbNav />` components. */
  children: PropTypes.node.isRequired,
  /** size property is used to defined the size of the Breadcrumb. */
  size: PropTypes.string,
  /** color property is used to defined the color of the Breadcrumb. */
  color: PropTypes.oneOf(Object.values(BREADCRUMB_COLOR))
};

export function BreadcrumbNav(props) {
  const { route, children, onClick = null, className } = props;
  const { color = BREADCRUMB_COLOR.BLUE } = useContext(BreadCrumbContext);

  function getSize() {
    if (color === BREADCRUMB_COLOR.BLUE) {
      return LINK_SIZE.MEDIUM;
    } else {
      return LINK_SIZE.BASE;
    }
  }

  //use onClick event to handle condtion based routing.
  //route takes more precidancy compare to onClick,
  return route || onClick ? (
    <Link
      color={color}
      size={getSize()}
      className={`${styles.breadcrumbnavlink} ellipsis ${className}`}
      route={route}
      onClick={onClick}
    >
      {children}
    </Link>
  ) : (
    <span
      className={`${styles.breadcrumbnav} ${
        color === BREADCRUMB_COLOR.BLUE ? "smallplus" : "base-600"
      } ellipsis ${className}`}
    >
      {children}
    </span>
  );
}

BreadcrumbNav.propTypes = {
  /** A link to redirect when the user clicks on it. */
  route: PropTypes.string,
  /** A component that will act as a breadcrumb link. */
  children: PropTypes.node.isRequired,
  /** color property is used to defined the color of the BreadcrumbNav. */
  color: PropTypes.string,
  /** The callback function that is triggered when user click on the BreadcrumbNav . */
  onClick: PropTypes.func,
  /** To overwrite the css properties . */
  className: PropTypes.string
};
